export default __webpack_public_path__ + "static/media/lain_speak_outro.6ec6a962.png";